// extracted by mini-css-extract-plugin
export default {"hideTooltip":"V8-z","fadeIn":"W8-z","delay":"X8-z","recommendedSizeTooltip":"Y8-z"};